import { memo } from 'react';

function InfoFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 1.334a6.667 6.667 0 100 13.333A6.667 6.667 0 008 1.334zm.667 9.333a.667.667 0 11-1.334 0V7.334a.667.667 0 011.334 0v3.333zM7.333 5.334a.667.667 0 101.334 0 .667.667 0 00-1.334 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default memo(InfoFillIcon);
